import React from "react";
import AdminHeader from "../../../components/admin/AdminHeader";
import { AdminFooter } from "../../../components/admin/AdminFooter";
import AdminAbout from "../../../views/admin/cms/AdminAbout";

const AdminAboutAddPage = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <AdminHeader />
        <AdminAbout />
      <AdminFooter />
    </div>
  );
};

export default AdminAboutAddPage;
